import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let CodeBlockComp;

class Code_block extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: CodeBlockComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/code-block-comp" */
            "../../../components/javascript/zcat-components/code-block-comp"
        ).then(function(res) {
            CodeBlockComp = res.CodeBlockComp;
        }));

        
;
    }
}

export {Code_block};

